var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('h2',[_vm._v(" Exhalation #"+_vm._s(_vm.exhale_num)+" done ")]),_c('h3',[_vm._v(" Press record when you are ready for the next breath session.")])])}
var staticRenderFns = []

export { render, staticRenderFns }